import { render, staticRenderFns } from "./user-card.vue?vue&type=template&id=457825fc&scoped=true"
import script from "./user-card.vue?vue&type=script&lang=ts"
export * from "./user-card.vue?vue&type=script&lang=ts"
import style0 from "./user-card.vue?vue&type=style&index=0&id=457825fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457825fc",
  null
  
)

export default component.exports